import { Injectable } from '@angular/core';
import { PrimaryAddress } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { ExtendedAddress } from '@lsq-frontend/remote-services/enterprise/common';
import { SupportedBankCountry, SupportedBankTransferType } from '../../../constants/bank.constants';
import { AddBankAccountFormService } from './add-bank-account-form.service';
import { AddIntlBankAccountFormService } from './add-intl-bank-account-form.service';
import { SupportedBankPaymentMethod } from './bank-accounts.models';

@Injectable({ providedIn: 'root' })
export class BankAccountFormControllerService {
    private supportedBankPaymentMethod: SupportedBankPaymentMethod;

    constructor(
        private _addIntlBankAccountFormService: AddIntlBankAccountFormService,
        private _addBankAccountFormService: AddBankAccountFormService
    ) {}

    public async submitForm(
        isEnrolling = false,
        options?: { sellerKey: string; companyKey: string; isInternational?: boolean }
    ): Promise<void> {
        if (
            (this.supportedBankPaymentMethod &&
                this.supportedBankPaymentMethod.country === SupportedBankCountry.UNITED_STATES &&
                this.supportedBankPaymentMethod.transferType === SupportedBankTransferType.ACH) ||
            !this.supportedBankPaymentMethod
        ) {
            await this._addBankAccountFormService.submitForm(isEnrolling, { ...options });
        } else {
            await this._addIntlBankAccountFormService.submitForm(
                isEnrolling,
                this.supportedBankPaymentMethod,
                { ...options }
            );
        }
    }

    public async initFormGroup(companyInformation?: {
        companyAddress: PrimaryAddress | ExtendedAddress;
        companyName: string;
    }): Promise<void> {
        await this._addIntlBankAccountFormService.loadCompanyInfo(companyInformation);
        this._addBankAccountFormService.initFormGroup();
        this._addIntlBankAccountFormService.initFormGroup();
    }

    public setBankPaymentMethod(bankPaymentMethod: SupportedBankPaymentMethod): void {
        this.supportedBankPaymentMethod = bankPaymentMethod;
    }
}
